import * as corosSportConfig from '@coros/sport-config';
const TARGET_UNIT_TYPE = corosSportConfig.basic.TARGET_UNIT_TYPE;

// 编辑历史游泳训练课程时
// 从第一个开始查找目标是距离的，找到一个停止，如果这个的单位为 mile yard 的，就是 25 yard。其余都算25m
export function checkFirstExerciseTargetUnitIsYardOrMile(exercises: any[]) {
  for (let i = 0; i < exercises.length; i++) {
    const exercise = exercises[i];
    // console.log(`exercise.targetDisplayUnit`, exercise.targetType, exercise.targetValue, exercise.targetDisplayUnit);
    if (exercise.targetType === 5) {
      if ([TARGET_UNIT_TYPE.MI, TARGET_UNIT_TYPE.YD].includes(exercise.targetDisplayUnit)) {
        return true;
      } else {
        return false;
      }
    }
  }
  return false;
}
